import { GlobalState } from '../../../../../store/reducers';
import {
    getDiagnosis,
    getElementsFromPrescription,
    getExaminations,
    getInjections,
    getLabTests,
    getLabVitals,
    getMedications,
    getSymptoms,
} from '../../../../../store/selectors/prescriptionPad';
import { Procedure } from '../../../../../store/types/prescription';

type PxToolKeyOptions = typeof PxToolKeyOptions[keyof typeof PxToolKeyOptions];

const PxToolKeyOptions = {
    labTests: {
        selectorFunc: getLabTests,
        kind: 'LAB_TESTS_KIND',
        showTemplateIconText: 'Panel',
        showTemplateIconTextColor: 'text-darwin-accent-investigations-ochre-800',
        showTemplateIconFillColor: 'fill-darwin-accent-investigations-ochre-800',
        tooltipText: 'Investigations',
        showTemplateBackgroundColor: '',
    },
    labVitals: {
        selectorFunc: getLabVitals,
        kind: 'LAB_VITALS_KIND',
        showTemplateIconText: 'Inv',
        showTemplateIconTextColor: 'text-darwin-accent-bright-yellow-900',
        showTemplateIconFillColor: 'fill-darwin-accent-bright-yellow-900',
        tooltipText: 'Lab Results',
        showTemplateBackgroundColor: '',
    },
    examinations: {
        selectorFunc: getExaminations,
        kind: 'EXAMINATIONS_KIND',
        showTemplateIconText: 'O/E',
        showTemplateIconTextColor: 'text-darwin-accent-examination-findings-sky-blue-900',
        showTemplateIconFillColor: 'fill-darwin-accent-examination-findings-sky-blue-900',
        tooltipText: 'Examinations Findings',
        showTemplateBackgroundColor: '',
    },
    medications: {
        selectorFunc: getMedications,
        kind: 'MEDICINES_KIND',
        showTemplateIconText: 'Mx',
        showTemplateIconTextColor: 'text-darwin-accent-medicines-pink-800',
        showTemplateIconFillColor: 'fill-darwin-accent-medicines-pink-800',
        tooltipText: 'Medications',
        showTemplateBackgroundColor: '',
    },
    injections: {
        selectorFunc: getInjections,
        kind: 'INJECTIONS_KIND',
        showTemplateIconText: 'Inj',
        showTemplateIconTextColor: 'text-darwin-accent-medicines-pink-800',
        showTemplateIconFillColor: 'fill-darwin-accent-medicines-pink-800',
        tooltipText: 'Injections',
        showTemplateBackgroundColor: '',
    },
    diagnosis: {
        selectorFunc: getDiagnosis,
        kind: 'DIAGNOSIS_KIND',
        showTemplateIconText: 'Dx',
        showTemplateIconTextColor: 'text-darwin-accent-diagnosis-purple-800',
        showTemplateIconFillColor: 'fill-darwin-accent-diagnosis-purple-800',
        tooltipText: 'Diagnosis',
        showTemplateBackgroundColor: '',
    },
    symptoms: {
        selectorFunc: getSymptoms,
        kind: 'SYMPTOMS_KIND',
        showTemplateIconText: 'Sx',
        showTemplateIconTextColor: 'text-darwin-accent-symptoms-blue-800',
        showTemplateIconFillColor: 'fill-darwin-accent-symptoms-blue-800',
        tooltipText: 'symptoms',
        showTemplateBackgroundColor: '',
    },
    PX: {
        kind: 'PX',
        showTemplateIconTextColor: 'text-darwin-accent-burgandy-800',
        showTemplateIconFillColor: 'fill-darwin-accent-burgandy-800',
        showTemplateBackgroundColor: 'bg-darwin-accent-burgandy-200',
    },
    procedures: {
        selectorFunc: (state: GlobalState) =>
            getElementsFromPrescription<Procedure>('procedures')(state),
        kind: 'PROCEDURES_KIND',
        showTemplateIconText: 'Pr',
        showTemplateIconTextColor: 'text-neutral-2',
        showTemplateIconFillColor: 'fill-neutral-2',
        tooltipText: 'Procedures',
        showTemplateBackgroundColor: '',
    },
};

export default PxToolKeyOptions;
